//#endregion Imports
import { faDown, faUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  ThemeProvider,
  Typography,
  createTheme,
  Grid,
  Button,
} from '@mui/material';

import variables from '../../scss/_variables.scss';
//#endregion

const theme = createTheme({
  palette: {
    primary: {
      main: variables.redDabi,
    },
    secondary: {
      main: '#6c757d',
    },
  },
});

const MovementItem = ({ index, handleDelete, movementInfo, item }) => {
  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        px={2}
        py={1}
        sx={{
          transition: 'background-color 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&:hover .delete-button': {
            opacity: 1,
          },
        }}
      >
        <Grid item xs={2}>
          <img
            alt={`movement-${item.name}`}
            src={item.image_url}
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item container xs={9}>
          <Grid item container xs={12}>
            <Grid item xs={3}>
              <Typography color='primary' fontWeight={600}>
                {movementInfo.typeName}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography color='primary' fontWeight={600}>
                {item.code}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>{item.name}</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={6}>
              <Typography>
                <span style={{ fontWeight: 'bold' }}>Modelo: </span>
                {item.model}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>
                <span style={{ fontWeight: 'bold' }}>Fabricante: </span>
                {item.manufacturer_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={6}>
              <Typography>
                <span style={{ fontWeight: 'bold' }}>Amacén: </span>
                {movementInfo.warehouseName}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>
                <span style={{ fontWeight: 'bold' }}>Ubicación: </span>
                {movementInfo.locationName}
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={6}>
              <Typography>
                <span style={{ fontWeight: 'bold', marginRight: '2%' }}>
                  Encargado:
                </span>
                {movementInfo.supervisorName}
              </Typography>
            </Grid>
            {movementInfo.isInput && (
              <Grid item xs>
                <Typography>
                  <span style={{ fontWeight: 'bold' }}>Proveedor: </span>
                  {movementInfo.provider}
                </Typography>
              </Grid>
            )}
            {!movementInfo.isInput && (
              <Grid item xs>
                <Typography>
                  <span style={{ fontWeight: 'bold' }}>Receptor: </span>
                  {movementInfo.receiverName}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Grid item container xs={12}>
            <Typography>
              <span style={{ fontWeight: 'bold' }}>Razón: </span>
              {movementInfo.reason}
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={1}>
          <Grid item xs={12} display='flex'>
            <Typography fontWeight={600} textAlign='start'>
              Cantidad:
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display='flex'
            alignItems='center'
            justifyContent='space-around'
          >
            <Typography variant='h5'>{movementInfo.quantity}</Typography>
            {movementInfo.isInput ? (
              <FontAwesomeIcon icon={faUp} size='2x' color='green' />
            ) : (
              <FontAwesomeIcon icon={faDown} size='2x' color='red' />
            )}
          </Grid>
          <Box display='flex' alignItems='center' justifyContent='center'>
            <Button
              fullWidth
              className='delete-button'
              sx={{
                opacity: 0,
                transition: 'opacity 0.3s easear',
                marginRight: 'auto',
                marginLeft: 'auto',
              }}
              color='primary'
              onClick={() => handleDelete(index)}
            >
              Eliminar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default MovementItem;
